import { environment } from '@/environments/environment';
import { Component } from '@angular/core';
import { NavLinksComponent } from '../../components/nav-links/nav-links.component';

@Component({
  selector: 'app-not-found',
  imports: [NavLinksComponent],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
})
export class NotFoundComponent {
  readonly robotImgPath = `${environment.cdnRoot}/images/${environment.cdnAssetTenantName}/default/payment_center/default/robot-error.svg`;
  readonly logoImgPath = `${environment.cdnRoot}/images/${environment.cdnAssetTenantName}/default/payment_center/default/firstech-logo-white.svg`;
}
